type ValueOf<T> = T[keyof T];

export const ANALYTICS_TAB_HASHES = {
  ACTIVITY: '#activity' as const,
  WELLBEING: '#wellbeing' as const,
  MANAGER_REPORTING: '#manager_reporting' as const,
};

export const ADMIN_TAB_HASHES = {
  MANAGE_USERS: '#manage_users' as const,
};

export type AnalyticsTabHash = ValueOf<typeof ANALYTICS_TAB_HASHES>;
export type AdminTabHash = ValueOf<typeof ADMIN_TAB_HASHES>;
